import { IRewardClaimDetailMessage } from "../mock";
import { useState } from "react";
import { FaPaperPlane } from "react-icons/fa6";
import dayjs from "dayjs";

interface IProps {
  messages: IRewardClaimDetailMessage[];
}

export function RewardOwnerChat({ messages }: IProps) {
  const [text, setText] = useState("");
  const [currentMessages, setCurrentMessages] = useState(messages);

  function sendMessage() {
    if (!text.trim()) return;

    setCurrentMessages((prev) => [
      ...prev,
      {
        id: Date.now(),
        author: "client",
        name: "Você",
        text,
        createdAt: new Date().toISOString(),
      },
    ]);
    setText("");
  }

  return (
    <div className="card h-100">
      <div className="card-header">
        <div className="card-title">Conversa com o Proprietário</div>
        <div className="card-category">
          Canal mockado para alinhamento da entrega.
        </div>
      </div>
      <div className="card-body">
        <div className="d-grid gap-3 mb-3">
          {currentMessages.map((message) => (
            <div
              className={`d-flex ${
                message.author === "client"
                  ? "justify-content-end"
                  : "justify-content-start"
              }`}
              key={message.id}
            >
              <div
                className={`border rounded p-3 ${
                  message.author === "client" ? "bg-light" : "bg-white"
                }`}
                style={{ maxWidth: 520 }}
              >
                <div className="d-flex justify-content-between gap-3 mb-1">
                  <span className="fw-semibold">{message.name}</span>
                  <small className="text-muted">
                    {dayjs(message.createdAt).format("DD/MM/YYYY HH:mm")}
                  </small>
                </div>
                <div className="text-muted">{message.text}</div>
              </div>
            </div>
          ))}
        </div>

        <label className="form-label fw-semibold">Mensagem</label>
        <textarea
          className="form-control mb-2"
          rows={4}
          value={text}
          onChange={(evt) => setText(evt.target.value)}
          placeholder="Digite sua mensagem para o proprietário da campanha."
        />
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-primary"
            onClick={sendMessage}
            title="Enviar mensagem ao proprietário."
          >
            <FaPaperPlane className="me-2" />
            Enviar mensagem
          </button>
        </div>
      </div>
    </div>
  );
}
